import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlbumCircleUser } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { CollectorAndReleaseDetails, ImageWrapper, Row, RowTitle } from './shared';

export const AllArtistCollaborationsRow = ({ artistName }: { artistName: string }) => {
  return (
    <Row center>
      <ImageWrapper>
        <FontAwesomeIcon icon={faAlbumCircleUser} size="1x" color="#ffffff" />
      </ImageWrapper>
      <CollectorAndReleaseDetails>
        <RowTitle>Any collaboration with {artistName}</RowTitle>
      </CollectorAndReleaseDetails>
    </Row>
  );
};
